/**
 * PublicMinistryService
 * Anonymous-safe ministry surface for the public Resource Centre.
 * Route: api/public/ministries (DepartmentManagement microservice)
 */
import { BaseService } from '../base/BaseService';
export class PublicMinistryService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicMinistryService.DEFAULT_SERVICE_PATH,
            basePath: PublicMinistryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async list(isActive) {
        const response = await this.listRaw(isActive);
        return response.data ?? [];
    }
    listRaw(isActive) {
        const suffix = isActive != null ? `?isActive=${isActive}` : '';
        return this.http.get(this.buildUrl(suffix));
    }
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(String(id)));
    }
}
PublicMinistryService.DEFAULT_SERVICE_PATH = 'departments';
PublicMinistryService.BASE_PATH = 'api/public/ministries';
//# sourceMappingURL=PublicMinistryService.js.map